import useFavoritesEdit from './use-favorites-edit';

export { useFavoritesEdit };

export default useFavoritesEdit;
